import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { AdvertiseComponent } from './advertise.component';
import { AdvertiseRoutingModule } from './advertise-routing.module';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Atuar na conversão do header para que as Apis do TI, consigam 
// receber as aquisições corretamente com Json via "RESPONSE HEADERS" e "REQUEST HEADERS"
import { Interceptor } from 'src/app/core/interceptors/http-request-interceptor';

@NgModule({
  declarations: [
    AdvertiseComponent
  ],
  imports: [
    CommonModule,
    RouterModule,    
    AdvertiseRoutingModule,
    NgbModule,
    HttpClientModule,
    Interceptor
  ]
})
export class AdvertiseModule { }
